<div 
  class="overlay"
  *ngIf="spinner.isShown"
  [class.full-screen]="spinner.fullScreen"
>
  <mat-spinner [diameter]="sizes[spinner.size]"></mat-spinner>
</div>